export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Software Engineer",
    company: "Tech Corp",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    content: "Duke's Python course transformed my career! His teaching style is clear and practical. I went from knowing nothing to building my first web application in just 8 weeks.",
    rating: 5,
    course: "Python Programming"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Data Analyst",
    company: "Data Insights Inc",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    content: "The React course was exactly what I needed to transition into frontend development. Duke's mentorship helped me land my dream job at a startup.",
    rating: 5,
    course: "React Development"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "DevOps Engineer",
    company: "Cloud Solutions",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    content: "Duke's DevOps course gave me the confidence to work with Kubernetes and AWS. His real-world examples made complex concepts easy to understand.",
    rating: 5,
    course: "DevOps & Cloud"
  },
  {
    id: 4,
    name: "David Kim",
    role: "ML Engineer",
    company: "AI Innovations",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    content: "The machine learning course was comprehensive and well-structured. Duke's guidance helped me build my first ML model and deploy it successfully.",
    rating: 5,
    course: "Machine Learning"
  },
  {
    id: 5,
    name: "Lisa Wang",
    role: "Business Analyst",
    company: "Finance Corp",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1476&q=80",
    content: "Duke's data analysis course helped me automate my reporting tasks and gain insights I never knew were possible. Highly recommended!",
    rating: 5,
    course: "Data Analysis"
  },
  {
    id: 6,
    name: "Alex Thompson",
    role: "Frontend Developer",
    company: "Web Studio",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
    content: "Starting from zero, Duke's web development course gave me all the skills I needed to build professional websites. The hands-on approach was perfect.",
    rating: 5,
    course: "Web Development"
  }
];

export const successStories = [
  {
    id: 1,
    student: "Sarah Johnson",
    before: "Marketing Coordinator",
    after: "Software Engineer at Tech Corp",
    timeline: "6 months",
    course: "Python Programming",
    story: "Sarah started with zero programming experience and now works as a full-stack developer, earning 40% more than her previous role."
  },
  {
    id: 2,
    student: "Michael Chen",
    before: "Accountant",
    after: "Data Analyst at Data Insights Inc",
    timeline: "4 months",
    course: "Data Analysis",
    story: "Michael transitioned from accounting to data analysis, using his new skills to help his company make data-driven decisions."
  },
  {
    id: 3,
    student: "Emily Rodriguez",
    before: "System Administrator",
    after: "DevOps Engineer at Cloud Solutions",
    timeline: "8 months",
    course: "DevOps & Cloud",
    story: "Emily advanced her career by learning modern DevOps practices, now managing cloud infrastructure for a growing company."
  }
];
